import type { ShopRepository } from "../types";
import { apiShopRepository } from "./apiShopRepository";
import { localShopRepository } from "./localShopRepository";

// Set VITE_USE_LOCAL_STORE=true to run the UI fully offline against
// localStorage (no backend). Defaults to the API-backed repository.
const useLocalStore = import.meta.env.VITE_USE_LOCAL_STORE === "true";

export const shopRepository: ShopRepository = useLocalStore
  ? localShopRepository
  : apiShopRepository;
